function CustomerRequests() {
  return <div>Customer Requests</div>;
}

export default CustomerRequests;
